import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../../Miscelania/RequestApi';

class ScheduleGradeCommentsEdit extends Component {
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed',
      },
      redirect_url: false,
      loaded: 0,
      id: this.props.schedule_grade_comment_id,
      comments: this.props.comments,
      status: this.props.status,
    };

    //bind específico
    this.edit = this.edit.bind(this);
  }

  // Handlers
  handleChange (name, event) {
    var change = {};
    change[name] = event.target.value;
    this.setState(change);
  }
  // LM
  componentWillReceiveProps(newProps) {
    if((this.state.loaded === 0 && typeof newProps.comments !== 'undefined')) {
      this.setState({
        comments: newProps.comments,
        status: newProps.status,
        loaded: 1,
      });
    }
    if((this.state.loaded === 1 && newProps.updated === 1)) {
      this.setState({
        comments: newProps.comments,
        status: newProps.status,
        loaded: 1,
      });
      this.props.resetUpdated();
    }
  }
  

  // Salva edição de comentário
  edit(event) {
    event.preventDefault();
    this.props.handleAlert('', '', 'open');
    var datasave = {
      id: this.state.id,
      comments: this.state.comments,
    };
    var header = this.refs.request_api.header('application/json');
    var self = this;
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/escala/grade/comentario/editar', { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        self.props.handleAlert(responseJson.message, responseJson.status, 'open');
      }).catch((error) => {
        console.error(error);
      });
    });
  }

  render() {
    var self = this;
    return (
      <div>
        {(this.props.status === 'rascunho') ?
          <form onSubmit={this.edit} className="row">
            <RequestApi ref={'request_api'} />
            <div className="col-md-9 col-md-offset-1">
              <textarea style={{ height: 66 }} type="text" placeholder="Comentários" name="comments" className="form-control" value={this.state.comments} onChange={this.handleChange.bind(this, 'comments')} />
            </div>
            <div className="col-md-2 text-left"><button className="btn btn-primary"><i className="fa fa-fw fa-save"></i></button></div>
          </form>
        :
          <div>{this.state.comments}</div>
        }
      </div>
    );
  }
}

export default ScheduleGradeCommentsEdit;



// WEBPACK FOOTER //
// ./src/Components/ScheduleGrades/Elements/ScheduleGradeCommentsEdit.js